import {Status, UrlSelection} from 'commonTypes'
import {
  JobRequestCategory,
  KafkaTopicState,
  JobCreatorOptions,
  JobRequest,
  PageInfo, Scalars,
  DataVerificationHashObject,
} from 'graphql-api'

export type DatabaseOptionType = {
  databaseId: string,
  raveUrl: string,
  hostname: string
}

export type StudyOptionType = {
  studyUuid: string,
  studyName: string,
}

export type StudyEnvironmentOptionType = {
  studyId: number,
  studyEnvironmentUuid: string,
  studyEnvironmentName: string,
}

export type SelectorOptionType = {
  label: string,
  value: string,
  disabled?: boolean,
  graphQlOption?: null
}

export type TopicOptionType = {
  label: string,
  value: KafkaTopicState,
  disabled?: boolean,
  graphQlOption?: null
}

export type filterOptionsType = {
  value: string,
  gql: string,
  label: string
}

const defaultJobRequestState = {
  gridSession: {
    pageSizeOptions: [10, 25, 50, 100],
    pageInfo: {
      startCursor: null as string | null,
      endCursor: null as string | null,
      hasNextPage: false,
      hasPreviousPage: false,
    } as PageInfo,
    pageCount: 0,
    showFilters: false,
    showJobCreateRequestForm: false,
  },
  status: Status.IDLE,
  error: null as any,
  dataLoadRequestDetails: null as JobStatusRequestNodeType,
  statusDetails: Status.IDLE,
  requestIdDetails: '',
  showDetails: false,

  jobRequestOptions: [] as JobCreatorOptions[],
  dataVerificationHashObjectOptions: [] as DataVerificationHashObject[],
  statusDataLoad: Status.IDLE,

  dataLoadTopicOptions: [] as TopicOptionType[],

  jobRequestCategory: {
    value: '' as JobRequestCategory,
    label: '',
  },

  dataLoadTopic: {
    value: null as KafkaTopicState | null,
    label: '',
  },

  specifiedUrls: '' as string,
  urlSelectionType: UrlSelection.ONE,

  database: {
    databaseOptions: [] as DatabaseOptionType[],
    hostname: '',
    databaseId: '',
  },
  dataVerificationHashObject: null as DataVerificationHashObject | null,
  changesAfterDate: '' as Scalars['DateTime'],
  changesAfterTime: '' as Scalars['DateTime'],
  objectId: '' as string,
  study: {
    studyOptions: [] as StudyOptionType[],
    studyName: '',
    studyUuid: null as Scalars['UUID'],
  },
  studyEnvironment: {
    studyEnvironmentOptions: [] as StudyEnvironmentOptionType[],
    studyId: 0,
    studyEnvironmentName: '',
    studyEnvironmentUuid: null as Scalars['UUID'],
  },
  jobRequestsHistory: {
    totalCount: 0,
    jobStatusRequests: [],
  },
}

export type JobRequestStateType = typeof defaultJobRequestState

export type JobStatusRequestNodeType = JobRequest | null | undefined

export default defaultJobRequestState
